/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Button, Input, InputLabel, MenuItem, Select } from '@mui/material'
import {
  REVIEW_STATUS,
  REVIEW_SEARCH_STATUS_MESSAGES,
  REVIEW_RESULT,
  REVIEW_SEARCH_RESULT_MESSAGES,
} from 'utils/constants/kypStatuses'
import { doesInputMatchCPFFormat } from 'utils/functions'
import { cloneDeep } from 'lodash'
import { SearchOutlined } from '@mui/icons-material'
import SwitchContainer from 'components/SwitchContainer'
import CustomSwitch from 'components/CustomSwitch'
import { styles } from './styles'

const initialValues = {
  search_text: '',
  status: REVIEW_STATUS.ALL,
  result: REVIEW_RESULT.ALL,
  include_subordinate_reviews: false,
}

const ManualAnalysisSearchBar = (props) => {
  const { setSearchParams } = props

  const classes = styles()

  const [formState, setFormState] = useState(initialValues)

  const handleUpdateFormState = (event) => {
    const key = event.target.name
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const handleSubmitSearch = () => {
    const searchParams = cloneDeep(formState)
    const textParam = doesInputMatchCPFFormat(searchParams.search_text) ? 'applicant_cpf' : 'applicant_name'
    const queryParams = {
      status:
        searchParams.status === REVIEW_STATUS.ALL ? null : searchParams.status,
      include_reviews_for_subordinates:
        searchParams.include_subordinate_reviews,
      result:
        searchParams.result === REVIEW_RESULT.ALL ? null : searchParams.result,
    }
    if (searchParams.search_text !== '') {
      queryParams[textParam] = searchParams.search_text
    }

    setSearchParams(queryParams)
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSubmitSearch()
    }
    return false
  }

  const handleShowSubordinateReviewsChange = () => {
    const newFormState = cloneDeep(formState)
    newFormState.include_subordinate_reviews =
      !newFormState.include_subordinate_reviews
    setFormState(newFormState)
  }

  useEffect(() => {
    if (formState.search_text === '') handleSubmitSearch()
  }, [formState.search_text])

  useEffect(() => {
    handleSubmitSearch()
  }, [formState.status, formState.result, formState.include_subordinate_reviews])

  return (
    <div className={classes.root}>
      <div className={classes.leftWrapper}>
        <Input
          type="search"
          name="search_text"
          placeholder="Digite o CPF ou nome do assessor"
          value={formState.search_text}
          onChange={handleUpdateFormState}
          onKeyUp={handleEnter}
        />
        <Button onClick={handleSubmitSearch}>
          <SearchOutlined />
        </Button>
      </div>
      <div className={classes.rightWrapper}>
        <SwitchContainer
          leftLabelText="ocultar"
          rightLabelText="exibir"
          title="Alçadas inferiores"
          tooltipText="Ocultar ou exibir análises destinadas a colaboradores de alçadas inferiores."
        >
          <CustomSwitch
            id="show-switch"
            checked={formState.include_subordinate_reviews}
            onChange={handleShowSubordinateReviewsChange}
          />
        </SwitchContainer>
        <div className={classes.filterStatus}>
          <InputLabel id="status">Status:</InputLabel>
          <Select
            labelId="status"
            id="status"
            name="status"
            value={formState.status}
            onChange={handleUpdateFormState}
            autoWidth
            variant="standard"
          >
            {Object.keys(REVIEW_STATUS).map((key) => {
              return (
                <MenuItem
                  key={key}
                  style={{
                    fontSize: '1.25rem',
                  }}
                  value={REVIEW_STATUS[key]}
                >
                  {REVIEW_SEARCH_STATUS_MESSAGES[key]}
                </MenuItem>
              )
            })}
          </Select>
        </div>
        <div className={classes.filterStatus}>
          <InputLabel id="result">Resultado:</InputLabel>
          <Select
            labelId="result"
            id="result"
            name="result"
            value={formState.result}
            onChange={handleUpdateFormState}
            autoWidth
            variant="standard"
          >
            {Object.keys(REVIEW_RESULT).map((key) => {
              return (
                <MenuItem
                  key={key}
                  style={{
                    fontSize: '1.25rem',
                  }}
                  value={REVIEW_RESULT[key]}
                >
                  {REVIEW_SEARCH_RESULT_MESSAGES[key]}
                </MenuItem>
              )
            })}
          </Select>
        </div>
      </div>
    </div>
  )
}

ManualAnalysisSearchBar.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
}

export default ManualAnalysisSearchBar
